import { PopoverContentContainer, PopoverRoot } from '@/components/Popover';
import { usePopover } from '@/hooks/popover/usePopover';
import InfoQuestionCircleIcon from '@/images/InfoQuestionCircle.svg';
import styled from '@emotion/styled';
import { FloatingArrow } from '@floating-ui/react';

const StyledPopoverContentContainer = styled(PopoverContentContainer)`
    max-width: 400px;
`;

export const CreativityLevelTooltip = () => {
    const { isPopoverOpen, refs, floatingStyles, getFloatingProps, getReferenceProps, arrowProps } = usePopover({
        type: 'hover',
        options: { placement: 'top' },
        offsetOptions: { mainAxis: 15 },
    });

    return (
        <>
            <img src={InfoQuestionCircleIcon} alt="list item" width="12px" height="12px" ref={refs.setReference} {...getReferenceProps()} />

            {isPopoverOpen && (
                <PopoverRoot ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                    <FloatingArrow {...arrowProps} />
                    <StyledPopoverContentContainer>
                        Lower settings ensure consistency and reliability, ideal for factual queries. Higher settings encourage broader
                        interpretations, making responses more dynamic and engaging
                    </StyledPopoverContentContainer>
                </PopoverRoot>
            )}
        </>
    );
};
